module.exports = __webpack_public_path__ + "static/media/5.161142b6.jpg";